import { render } from "./RenderingRandselBag.vue?vue&type=template&id=3fa0eb0b&scoped=true&ts=true"
import script from "./RenderingRandselBag.vue?vue&type=script&lang=ts"
export * from "./RenderingRandselBag.vue?vue&type=script&lang=ts"

import "./RenderingRandselBag.vue?vue&type=style&index=0&id=3fa0eb0b&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa0eb0b"]])

export default __exports__